<template>
    <el-dialog
        :visible.sync="listDialogVisible"
        v-bind="config.dialogAttr"
     >
     <!-- :before-close="cancelCheck" -->
        <div class="from_content">
            <m-from ref="formDate" :config="config.fromComponent" @changeOrClear="changeOrClear" @onFromDataChange="onFromDataChange">
                <span :slot="item.slotName" v-for="item in config.fromComponent.slotComponent" :key="item.prop">
                    <slot :name="item.slotName"></slot>
                </span>
            </m-from>
        </div>
        <span slot="footer" class="dialog-footer" v-if="config.dialogFooter">
            <el-button @click="listDialogVisible = false" size="small" type="">
                取 消
            </el-button>
            <el-button @click="submit" size="small" type="primary">
                保 存
            </el-button>
        </span>
         <span slot="footer" v-else>
            <slot name="footer"></slot>
        </span>
    </el-dialog>
</template>

<script>
import mFrom from './mFrom';
export default {
    name: 'mDialog',
    components: { mFrom },
    props: {
        config: {
            type: Object,
            default() {
                return {};
            }
        },
        keepComponent: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            listDialogVisible: false
        };
    },

    mounted() {

    },

    methods: {
        open(val = {}) {
            this.listDialogVisible = true;
            this.$nextTick(() => {
                this.setFromData(val);
            });
        },
        setFromData(val) {
            this.$refs.formDate.setFromData(val);
        },
        submit() {
            this.$refs.formDate.submit((valid, fromData) => {
                if (valid) {
                    this.$emit('submit', fromData);
                    if (this.keepComponent) this.listDialogVisible = false;
                }
            });
        },
        hiedDialogVisible() {
            this.listDialogVisible = false;
        },
        changeOrClear(key, item) {
            this.$emit('changeOrClear', key, item);
        },
        onFromDataChange(val) {
            this.$emit('onFromDataChange', val);
        },
        resetFields() {
            this.$refs.formDate.resetFields();
        },
        clearValidate(arr) {
            this.$refs.formDate.clearValidate(arr);
        }
    },
    watch: {
        listDialogVisible(val) {
            this.$nextTick(() => {
                this.resetFields();
            });
            if (!val) {
                this.$refs.formDate.reset();
                this.$emit('close');
            }
        }
    }
};
</script>

<style lang="less" scoped>
.from_content{
    width: 100%;
}
</style>